import { combineReducers } from "redux"

import TutorReducer from './TutorReducer';
import StudentReducer from './StudentReducer';
import MasterReducer from './MasterReducer';


const rootReducer = combineReducers({
    TutorReducer,
    StudentReducer,
    MasterReducer

})

export default rootReducer;